var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-datatable',{attrs:{"modelName":_vm.model,"modelColumnDefs":_vm.columnDefs,"navigableDetail":false,"actions":_vm.actions,"showSearcher":false}}),_c('notificationexhibitorproductmodals',{attrs:{"modelName":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }